<template>
  <div
    class="cai-consent"
    role="dialog"
    aria-live="polite"
  >
    <div class="cai-consent__title">
      {{ title }}
    </div>
    <div class="cai-consent__text">
      {{ text }}
    </div>
    <div class="cai-consent__buttons">
      <button
        class="cai-consent__yes"
        :disabled="busy"
        @click="$emit('answer', true)"
      >
        Yes, save my chats
      </button>
      <button
        class="cai-consent__no"
        :disabled="busy"
        @click="$emit('answer', false)"
      >
        No thanks
      </button>
    </div>
  </div>
</template>

<script>
import { CONSENT_TITLE, CONSENT_TEXT } from '../caiApi'

export default {
  props: {
    busy: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      title: CONSENT_TITLE,
      text: CONSENT_TEXT
    }
  }
}
</script>
